import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { DataType } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";
const outputName = "object";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.buildObjectFromProperties,
  label: "Object From Fields",
  operationIcon: NodeOperationIcon.create,
  category: NodeTypeCategory.transformations,
  hideLabelOnAnchor: true,
  controlOutputs: [],
  dataInputs: [],
  documentDataInputListName: "properties",
  dataOutputs: [{ name: outputName, type: DataType.OBJECT }],
  inputsSchemaProperties: { identifiersOnly: false, excludeIdentifiers: true, schemaPropertyName: schemaProperty },
  nodeConfigProperties: [
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        dataProperties: [outputName],
        displayProperty: schemaNameProperty
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "inputs",
      sectionName: "Input",
      propertyType: NodeConfigPropertyType.EnabledInputs
    }
  ],
  size: NodeSize.Small,
  evaluate: (input, nodeProperties) => {
    let output: any = {};
    Object.keys(nodeProperties.outputs).forEach((outputName) => {
      if (nodeProperties.outputs[outputName].enabled) {
        output[outputName] = input.object ? (input.object as any)[outputName] : null;
      }
    });
    return { output: output, activeControlHandleIds: [] };
  }
});

export const BuildObjectFromPropertiesNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
